// extracted by mini-css-extract-plugin
export default {"games":"duelana-games_games__Gy1SC","games__list":"duelana-games_games__list__bduT-"};